export default {
  data() {
    return {
      RLZYForm: {
        ygrs: "",
        sfyygxq: "",
        ldygxql: "",
        lxggrys: "",
        wjczrys: "",
        bsyjsrs: "",
        ssyjsrs: "",
        bkrs: "",
        cbry: ""
      },
      RLZYRules: {
        ldygxql: [
          {
            required: true,
            message: "请选择劳动用工需求量",
            trigger: ["blur", "change"]
          }
        ]
      },
      selectList: [
        { name: "10人以下（含10人）", code: "ygrs_1" },
        { name: "10-50人（含50人）", code: "ygrs_2" },
        { name: "50-200人（含200人）", code: "ygrs_3" },
        { name: "200-500人（含500人）", code: "ygrs_4" },
        { name: "500-1000人（含1000人）", code: "ygrs_5" },
        { name: "1000人以上", code: "ygrs_6" }
      ]
    };
  },
  methods: {
    sfyygxqChange() {
      this.RLZYForm.ldygxql = "";
      this.$refs["RLZYForm"].clearValidate();
    }
  }
};
